import { MenuItem, Radio, SelectProps } from '@mui/material';
import { useState } from 'react';

import { Select } from '@/components';

interface SingleSelectDropdownProps {
  selectedOption: string;
  options: Record<string, { text: string }>;
  onSave: (value: string) => void;
  title: string;
  fullSize?: boolean;
  isFormInput?: boolean;
  sx?: SelectProps['sx'];
  error?: boolean;
}

export const SingleSelectDropdown = ({
  selectedOption,
  options,
  onSave,
  title,
  fullSize,
  isFormInput,
  sx,
  error,
}: SingleSelectDropdownProps) => {
  const [opened, setOpened] = useState(false);
  const selectTitle = `${title}${options[selectedOption]?.text || ''}`;

  return (
    <Select
      selectedOptions={selectedOption}
      isOpened={opened}
      onOpen={() => setOpened(true)}
      onClose={() => setOpened(false)}
      onChange={e => onSave(e?.target?.value as string)}
      title={selectTitle}
      fullSize={fullSize}
      isFormInput={isFormInput}
      sx={sx}
      error={error}>
      {Object.keys(options).map(key => (
        <MenuItem sx={styles.selectOption} key={key} value={key}>
          <Radio sx={styles.radio} checked={selectedOption === key} />
          {options[key].text}
        </MenuItem>
      ))}
    </Select>
  );
};

const styles = {
  selectOption: {
    whiteSpace: 'unset',
    wordBreak: 'break-word',
    pl: 0.5,
    '&.Mui-selected': {
      backgroundColor: 'secondary.medium',
    },
    '&:hover': {
      backgroundColor: 'grey50',
    },
    '&.Mui-selected:hover': {
      backgroundColor: 'grey50',
    },
  },
  radio: {
    '&.Mui-checked': {
      color: 'grey200',
    },
    '& .MuiSvgIcon-root': {
      fontSize: 16,
    },
  },
};
